import script from "./PopAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./PopAlert.vue?vue&type=script&setup=true&lang=js"

import "./PopAlert.vue?vue&type=style&index=0&id=7f0c2606&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0c2606"]])

export default __exports__